import isUrl from "is-url"
import { getEventTransfer } from "@convertkit/slate-react"

const handledTransferType = type => type === "text" || type === "html"

const embedTypes = [
  {
    name: "spotify",
    regex:
      /https?:\/\/.*spotify\.com\/(playlist|track|album|artist)\/.+(\?si=.+)?/,
    command: (editor, href) => {
      editor.insertSpotify({ href })
    }
  },
  {
    name: "tweet",
    regex: /http(?:s)?:\/\/(?:www\.)?(twitter|x)\.com\/.+\/status\/\d+(?:\/)?/,
    command: (editor, href) => {
      editor.insertTweet({ href })
    }
  }
]

export const pasteEmbeds = () => ({
  onPaste(event, editor, next) {
    const transfer = getEventTransfer(event)
    let embedMatch

    if (!handledTransferType(transfer.type)) return next()
    if (!isUrl(transfer.text)) return next()

    const embed = embedTypes.find(embedType => {
      embedMatch = transfer.text.match(embedType.regex)?.[0]
      if (embedMatch) {
        return embedType
      }
    })

    if (!embed) return next()
    // hacky way to feature flip pasted embeds
    if (editor.props[`${embed.name}Embed`] === false) return next()

    // send the regex match not the raw transfer.text as that could contain
    // unwanted values e.g in the case of twitter:
    // https://twitter.com/status/abc/photo/1 is the link to a twitter photo
    // that a user might paste but it's not a valid link for the API to parse
    // until we remove the /photo/1 which the regex match does.
    embed.command(editor, embedMatch)
  }
})
